import styled from "styled-components";

export const StyledLayout = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    flex-grow: 1;
    flex-shrink: 1;
    overflow: hidden;
`;